import { module } from 'angular';
import droitComponent from './droit.component';

export default module('app.droit', [])
	.component('droit', droitComponent)
	.name;
